// extracted by mini-css-extract-plugin
export default {"Container":"Notifications_Container__AEMru","wrapper":"Notifications_wrapper__hkZ4c","right":"Notifications_right__3OGQm","Notifications":"Notifications_Notifications__GbFNE"};